import useTranslation from "utils/hooks/useTranslation";

export type IDataInformation = {
  id: number;
  title: string;
  description: string;
};

export const checkinDataInformations = (): IDataInformation[] => {
  const VEHICLES_ARRIVING = useTranslation({ id: "vehicles_arriving" });
  const VEHICLES_ARRIVING_DESCRIPTION = useTranslation({ id: "vehicles_arriving_description" });
  const VEHICLES_IN_THE_RADIUS = useTranslation({ id: "vehicles_in_the_radius" });
  const VEHICLES_IN_THE_RADIUS_DESCRIPTION = useTranslation({ id: "vehicles_in_the_radius_description" });

  return [
    {
      id: 1,
      title: VEHICLES_ARRIVING,
      description: VEHICLES_ARRIVING_DESCRIPTION,
    },
    {
      id: 2,
      title: VEHICLES_IN_THE_RADIUS,
      description: VEHICLES_IN_THE_RADIUS_DESCRIPTION,
    },
  ];
};

export const releasedInformations = (): IDataInformation[] => {
  const RELEASED = useTranslation({ id: "released" });
  const RELEASED_DESCRIPTION = useTranslation({ id: "released_description" });
  const NOT_RELEASED = useTranslation({ id: "not_released" });
  const NOT_RELEASED_DESCRIPTION = useTranslation({ id: "not_released_description" });
  return [
    {
      id: 3,
      title: NOT_RELEASED,
      description: NOT_RELEASED_DESCRIPTION,
    },
    {
      id: 4,
      title: RELEASED,
      description: RELEASED_DESCRIPTION,
    },
  ];
};

export const inboundDataInformations = (): IDataInformation[] => {
  const VEHICLES_IN_LOCATION = useTranslation({ id: "vehicles_in_location_title" });
  const VEHICLES_IN_LOCATION_DESCRIPTION = useTranslation({ id: "vehicles_in_location_description" });
  const IN_OPERATION = useTranslation({ id: "in_operation" });
  const IN_OPERATION_DESCRIPTION = useTranslation({ id: "in_operation_description_info" });
  const INTERN_QUEUE = useTranslation({ id: "intern_queue" });
  const WAITING_OPERATION_DESCRIPTION = useTranslation({ id: "waiting_operation_description_info" });
  const FINISHED_OPERATION = useTranslation({ id: "finished_operation" });
  const FINISHED_OPERATION_DESCRIPTION = useTranslation({ id: "finished_operation_description" });
  const WARNING_FINISHED_OPERATION = useTranslation({ id: "requires_attention" });
  const WARNING_FINISHED_OPERATION_DESCRIPTION = useTranslation({ id: "warning_finished_operation_description" });
  return [
    {
      id: 5,
      title: VEHICLES_IN_LOCATION,
      description: VEHICLES_IN_LOCATION_DESCRIPTION,
    },
    {
      id: 6,
      title: INTERN_QUEUE,
      description: WAITING_OPERATION_DESCRIPTION,
    },
    {
      id: 7,
      title: IN_OPERATION,
      description: IN_OPERATION_DESCRIPTION,
    },
    {
      id: 8,
      title: FINISHED_OPERATION,
      description: FINISHED_OPERATION_DESCRIPTION,
    },
    {
      id: 8,
      title: WARNING_FINISHED_OPERATION,
      description: WARNING_FINISHED_OPERATION_DESCRIPTION,
    },
  ];
};
